import React from 'react';
import { useSelector } from 'react-redux';

import { Button, Col, Popover, Row } from 'antd';

import { colorPalette } from '../../../resources/styles/colorPalette';

import { selectDarkMode } from '../../../userBrowserSettings/store/browserSettings.selectors';
import { getThemeColorClass } from '../../../utils/helpers/themeHelpers';

import CloseIcon from '../../../resources/icons/CloseIcon';
import GenerateContentIcon from '../../../resources/icons/ai/GenerateContentIcon';

const classes = {
    runBriefPopoverWrapper: 'run-brief-popover-wrapper',
    runBriefOptionsWrapper: 'run-brief-options-wrapper',
    runAiOptimizerPopover: 'general-popover run-ai-optimizer-popover',
    runBriefOptionalBtn: 'run-brief-optional-btn',
    runAIBriefOptionalBtn: 'run-ai-brief-optional-btn',
    messageRow: 'message-row',
    popoverControlsRow: 'controls-row',
    closeButton: 'close-button',
};

const RunAiOptimizerPopover = ({
    isOpen,
    handleRunBrief = () => null,
    handleRunAIBrief = () => null,
    onClose = () => null,
    children,
}) => {
    const darkMode = useSelector(selectDarkMode);

    return (
        <Popover
            content={
                <div className={classes.runBriefPopoverWrapper}>
                    <Row wrap={false} justify='end' className={classes.popoverControlsRow}>
                        <Button
                            ghost
                            icon={<CloseIcon size='16' />}
                            className={classes.closeButton}
                            onClick={onClose}
                        ></Button>
                    </Row>
                    <div
                        className={`${classes.runBriefOptionsWrapper} ${getThemeColorClass(
                            darkMode
                        )}`}
                    >
                        <Row
                            wrap={false}
                            justify='center'
                            align='middle'
                            className={classes.messageRow}
                        >
                            <Col flex='30px'>
                                <GenerateContentIcon color={colorPalette.colorPrimary} />
                            </Col>
                            <Col flex='auto'>
                                Would you like to create your own content or use AI-generated
                                content?
                            </Col>
                        </Row>
                        <Row gutter={[0, 10]} justify='end' align='middle'>
                            <Col flex='none'></Col>
                            <Col flex='auto' align='right'>
                                <Button
                                    onClick={handleRunBrief}
                                    className={classes.runBriefOptionalBtn}
                                    size='small'
                                    block={false}
                                >
                                    Create my own content
                                </Button>
                                <Button
                                    onClick={handleRunAIBrief}
                                    className={classes.runAIBriefOptionalBtn}
                                    size='small'
                                    block={false}
                                >
                                    Use AI-generated content
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </div>
            }
            trigger={['click']}
            placement='topRight'
            overlayClassName={`${classes.runAiOptimizerPopover} ${getThemeColorClass(darkMode)}`}
            open={isOpen}
            onOpenChange={(visible) => !visible && onClose()}
        >
            <div>{children}</div>
        </Popover>
    );
};

export default RunAiOptimizerPopover;
